import axios from 'axios'
import settings from '../settings'

const instance = axios.create({
  baseURL: settings.baseUrl,
  // headers: token ? {'Authorization': `Bearer ${token}`} : {}
})

export default instance
